export default "__VITE_ASSET__CynalefF__"